import { Typography } from "@mui/material"

export function ScheduleCommentaryOverviewItem({ item }) {
    return (
        <Typography variant="body2" data-cy="schedule-commentary-overview-item">
            {item.text}
        </Typography>
    )
}
